import * as React from 'react';
import { ImageFilePreview } from './components/ImageFilePreview/ImageFilePreview.js'
import { StandardFilePreview } from './components/StandardFilePreview/StandardFilePreview.js'
import type { FilePreviewProps } from './types.js'

export function FilePreview(props: FilePreviewProps) {
  switch (props.variant) {
    case 'image':
      return <ImageFilePreview {...props} />

    case 'standard':
      return <StandardFilePreview {...props} />
  }
}
